// Session token for the API, kept in localStorage (per-browser convenience;
// the server can revoke it). Read synchronously by the tRPC link.
const TOKEN_KEY = 'dispence.web-session'
const listeners = new Set<() => void>()
let currentToken: string | null = read()

function read(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function getSessionToken() {
  return currentToken
}

export function setSessionToken(token: string | null) {
  currentToken = token
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token)
    else window.localStorage.removeItem(TOKEN_KEY)
  } catch {
    // private mode or blocked storage: the session lives for this tab only
  }
  for (const listener of listeners) listener()
}

export function subscribeSession(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
